import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";
import { GenerateFileOptions } from "../IGenerateFileOptions";

interface IFileTypeInvoice extends IExportableFile {
    privateBillId: string;
    ObjectId?: string;
}

class FileTypeInvoice extends ExportableFile implements IFileTypeInvoice {
    public canGenerateFileXcom: boolean = true;

    public privateBillId: string;
    public ObjectId: string;

    constructor(fields: IFileTypeInvoice) {
        super(FileType.Invoice);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.ObjectId ?? this.privateBillId; }

    public getCleanCopy(): FileTypeInvoice {
        return new FileTypeInvoice(this);
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected async generateFileIfNeededXcom(includeOverlays: boolean): Promise<IExportableFileLoaded> {
        return await this.generateFileIfNeeded({ includeOverlays: includeOverlays, isExternal: true });
    }

    protected generateFileIfNeeded(generateFileOption: GenerateFileOptions): Promise<IExportableFileLoaded> {
        const { isExternal } = generateFileOption;
        const fetchUrl =
            isExternal
                ? FileSelectionHelper.getFetchUrlXcom(this.clientTag, this.claimId, this.privateBillId, this.fileType, { noCache: true })
                : FileSelectionHelper.getFetchUrl(this.privateBillId, this.fileType, { noCache: true });

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }
}

export { FileTypeInvoice };
